import Skeleton, { type SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//https://github.com/dvtng/react-loading-skeleton

type LoadingSkeletonProps = Omit<SkeletonProps, 'containerTestId'> & {
  // react-loading-skeleton drops `data-testid`; it only stamps a test id via `containerTestId`.
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'data-testid'?: string;
};

export default function LoadingSkeleton({
  borderRadius = 6,
  baseColor = '#eaeaea',
  'data-testid': testId,
  ...props
}: LoadingSkeletonProps) {
  return <Skeleton {...props} containerTestId={testId} borderRadius={borderRadius} baseColor={baseColor} />;
}
